import React from "react";

type ElementInfo = {
  scrollLeft: number;
  clientWidth: number;
  scrollWidth: number;
  scrollTop: number;
  clientHeight: number;
  scrollHeight: number;
};

export default function useScrollInfo(params: {
  ref: React.RefObject<HTMLDivElement>;
  direction: "horizontal" | "vertical";
  offset?: number;
}) {
  const { ref, direction } = params;
  const [isTouched, setIsTouched] = React.useState(false);
  const [elementInfo, setElementInfo] = React.useState<ElementInfo | null>(null);

  React.useEffect(() => {
    const element = ref.current;

    if (element === null) return;

    const handleScroll = () => {
      switch (direction) {
        case "horizontal": {
          if (element.scrollLeft !== 0) {
            setIsTouched(true);
          }
          break;
        }

        case "vertical": {
          if (element.scrollTop !== 0) {
            setIsTouched(true);
          }
          break;
        }
      }

      setElementInfo({
        scrollLeft: element.scrollLeft,
        clientWidth: element.clientWidth,
        scrollWidth: element.scrollWidth,
        scrollTop: element.scrollTop,
        clientHeight: element.clientHeight,
        scrollHeight: element.scrollHeight,
      });
    };

    element.addEventListener("scroll", handleScroll);

    return () => {
      element.removeEventListener("scroll", handleScroll);
    };
  }, [ref, direction, params.offset]);

  const offset = params.offset ?? 0;

  const isEndOfScroll =
    elementInfo === null
      ? false
      : direction === "horizontal"
      ? elementInfo.scrollLeft + elementInfo.clientWidth + offset >= elementInfo.scrollWidth
      : elementInfo.scrollTop + elementInfo.clientHeight + offset >= elementInfo.scrollHeight;

  return { isEndOfScroll, isTouched };
}
